import { ServiceModel } from '../../../domain/models'

import ItemAccordion from './item'

import * as S from './styles'

type AccordionTableProps = {
  rows: ServiceModel[]
  handleOpenEditModal: any
  idCustomer: string | number
}

const AccordionTable = ({
  rows,
  handleOpenEditModal,
  idCustomer
}: AccordionTableProps) => (
  <S.Wrapper>
    <table>
      <thead>
        <tr>
          <th>Serviços</th>
        </tr>
      </thead>

      <tbody>
        {rows?.map((item: ServiceModel) => (
          <ItemAccordion
            item={item}
            key={item.cdServico}
            handleOpenEditModal={handleOpenEditModal}
            idCustomer={idCustomer}
            lengthServices={rows.length}
          />
        ))}
      </tbody>
    </table>
  </S.Wrapper>
)

export default AccordionTable
